import { defineGame } from "./game-definition.js";
import { QUIZ_BUZZER_DEFINITION } from "./quiz-buzzer-definition.js";
import { scoreQuizAnswer } from "./quiz-buzzer-machine.js";
// These modules differ in their puzzles and pacing, not in round lifecycle.
// Keep the existing Question Engine authoritative for answers and scoring.
function puzzleDefinition(key, presentation, answerDurationMs) {
    const initialConfig = Object.freeze({
        rounds: 10, answerDurationMs, roundResultDurationMs: 4_000,
        correctBasePoints: 1_000, speedBonusMaxPoints: 500
    });
    return defineGame({
        ...QUIZ_BUZZER_DEFINITION,
        key,
        metadata: { ...QUIZ_BUZZER_DEFINITION.metadata, ...presentation },
        initialConfig,
        configurationProfiles: {
            quick: { configuration: { rounds: 5, answerDurationMs: answerDurationMs - 3_000, roundResultDurationMs: 3_000 }, estimatedMinutes: 4 },
            standard: { configuration: {}, estimatedMinutes: 7 },
            extended: { configuration: { rounds: 20, answerDurationMs: answerDurationMs + 3_000 }, estimatedMinutes: 14 }
        },
        createInitialState: (config = {}) => ({
            phase: "LOBBY", roundNumber: 0, totalRounds: config.rounds ?? initialConfig.rounds, pausedFromPhase: null
        }),
        scoreDelta: (decision) => scoreQuizAnswer(decision === "CORRECT", answerDurationMs, answerDurationMs, initialConfig),
        views: { host: `${presentation.slug}/host`, player: `${presentation.slug}/player`, display: `${presentation.slug}/display` }
    });
}
export const ANAGRAM_SPRINT_DEFINITION = puzzleDefinition("ANAGRAM_SPRINT", {
    slug: "anagram-sprint", name: "Anagramma Sprint", icon: "🔤",
    description: "Riordina mentalmente le lettere e scegli la parola giusta prima degli altri."
}, 15_000);
export const MATH_SPRINT_DEFINITION = puzzleDefinition("MATH_SPRINT", {
    slug: "math-sprint", name: "Calcolo Lampo", icon: "⚡",
    description: "Piccoli calcoli, grandi sfide: trova il risultato e conquista il bonus velocità."
}, 12_000);
export const NUMBER_SEQUENCE_DEFINITION = puzzleDefinition("NUMBER_SEQUENCE", {
    slug: "number-sequence", name: "Sequenza Misteriosa", icon: "🔢",
    description: "Scopri il numero mancante seguendo la regola della sequenza."
}, 15_000);
export const EMOJI_RIDDLE_DEFINITION = puzzleDefinition("EMOJI_RIDDLE", {
    slug: "emoji-riddle", name: "Indovina l’Emoji", icon: "🧩",
    description: "Decifra gli indizi emoji e scegli la risposta: oggetti, mestieri e idee quotidiane."
}, 15_000);
//# sourceMappingURL=party-puzzle-definitions.js.map